// React
import React from 'react';

const PETransition = (props) => {

  return (
    <div>
      <p>No content is needed for this page as the instructions handle whats shown to the learner.</p>
    </div>
  );
};

export default PETransition;